import moment from "moment"
import { FiltersState } from "../states"

type GraphQLViewFilter = {
  name: string
  values?: string[]
  startDate?: string
  endDate?: string
}

export const ORG_VIEW_NAME_BY_SUBPAGE: Record<string, string> = {
  organizations: "orgViewOrganizations",
  states: "orgViewStates",
  districts: "orgViewDistricts",
  schools: "orgViewSchools",
  admins: "orgViewAdmins",
  teachers: "orgViewTeachers",
  classes: "orgViewClasses",
  students: "orgViewStudents"
}

export const ORG_VIEW_ENTITY_FILTER_BY_SUBPAGE: Record<string, string> = {
  organizations: "organization",
  states: "state",
  districts: "district",
  schools: "school",
  admins: "admin",
  teachers: "teacher",
  classes: "class",
  students: "student"
}

const VIEW_FILTER_BY_REQUEST_PARAM: Record<string, string> = {
  "org_view_organizations.id": "organization",
  "org_view_organizations.states": "state",
  "org_view_states.code": "state",
  "org_view_states.state": "state",
  "org_view_districts.state": "state",
  "org_view_districts.districtId": "district",
  "org_view_districts.organizationId": "organization",
  "org_view_schools.districtId": "district",
  "org_view_schools.id": "school",
  "org_view_schools.schoolId": "school",
  "org_view_admins.id": "admin",
  "org_view_teachers.id": "teacher",
  "org_view_teachers.teacherId": "teacher",
  "org_view_teachers.districtId": "district",
  "org_view_teachers.schoolId": "school",
  "org_view_classes.id": "class",
  "org_view_classes.classId": "class",
  "org_view_classes.districtId": "district",
  "org_view_classes.schoolId": "school",
  "org_view_classes.teacherId": "teacher",
  "org_view_classes.studentId": "student",
  "org_view_students.studentId": "student",
  "org_view_students.schoolId": "school",
  "org_view_students.teacherId": "teacher",
  "org_view_students.classId": "class"
}

export const getViewFilterNameFromRequestParam = (requestParam?: string) =>
  requestParam ? VIEW_FILTER_BY_REQUEST_PARAM[requestParam] : null

const ACTIVITY_LOG_DETAIL_FILTER_BY_SUBPAGE_VIEW: Record<string, string> = {
  students_id: "student",
  teachers_id: "teacher"
}

export const getGraphQLDetailFilterName = ({
  requestParam,
  subpageView
}: {
  requestParam?: string
  subpageView?: string
}) => {
  if (requestParam === "usage_activity_logs.userId" && subpageView) {
    return ACTIVITY_LOG_DETAIL_FILTER_BY_SUBPAGE_VIEW[subpageView] ?? null
  }

  return getViewFilterNameFromRequestParam(requestParam)
}

export const getGraphQLViewDateFilter = (
  filters: FiltersState = {}
): GraphQLViewFilter | null => {
  const date = filters.date

  if (!date?.[0] || !date?.[1]) {
    return null
  }

  return {
    name: "date",
    startDate: moment(date[0], "YYYY-MM-DD").startOf("day").toISOString(),
    endDate: moment(date[1], "YYYY-MM-DD").endOf("day").toISOString()
  }
}

export const getGraphQLViewDetailFilters = ({
  entityId,
  filterName,
  filters
}: {
  entityId: string
  filterName: string
  filters?: FiltersState
}): GraphQLViewFilter[] => {
  const dateFilter = getGraphQLViewDateFilter(filters)

  return [
    {
      name: filterName,
      values: [entityId]
    },
    ...(dateFilter ? [dateFilter] : [])
  ]
}

export const getGraphQLViewFilters = ({
  filters = {},
  entityId,
  requestParam,
  subpageView
}: {
  filters?: FiltersState
  entityId?: string
  requestParam?: string
  subpageView?: string
}): GraphQLViewFilter[] => {
  const allFilters: GraphQLViewFilter[] = []
  const detailFilterName = getGraphQLDetailFilterName({
    requestParam,
    subpageView
  })

  if (typeof entityId === "string" && detailFilterName) {
    allFilters.push({
      name: detailFilterName,
      values: [entityId]
    })
  }

  for (const [key, values] of Object.entries(filters)) {
    if (key === "date") {
      const dateFilter = getGraphQLViewDateFilter(filters)

      if (dateFilter) {
        allFilters.push(dateFilter)
      }
    } else if (
      key !== detailFilterName &&
      Array.isArray(values) &&
      values.length > 0
    ) {
      allFilters.push({
        name: key,
        values
      })
    }
  }

  if (typeof entityId === "string" && !detailFilterName) {
    allFilters.push({
      name: "entityId",
      values: [entityId]
    })
  }

  return allFilters
}
